import { useSelector } from 'react-redux';

export function useVirtualRoom() {
    return useSelector((state) => state.ui.sidePanel.virtualRoom);
}
